import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Expandable } from 'design-system/client';
import analytics, { getDonationFormType } from 'product-analytics';
import { useEffect } from 'react';
import styles from './ZeroCodonationMessage.module.css';
import { useZeroCodonationMessageContext } from './ZeroCodonationMessageContext';
import I18nHtml from '@/components/I18nHtml';
import { useDonationFormConfig } from '@/donationPages/_dependencies/helpers';
function ZeroCodonationMessage(t0) {
  const $ = _c(28);
  const {
    value,
    onShow,
    className
  } = t0;
  const {
    receiverId,
    receiverType,
    channel,
    showCodonation
  } = useDonationFormConfig();
  const {
    shown,
    show
  } = useZeroCodonationMessageContext();
  let t1;
  if ($[0] !== channel || $[1] !== receiverId || $[2] !== receiverType || $[3] !== show || $[4] !== showCodonation || $[5] !== shown || $[6] !== value) {
    t1 = () => {
      if (value !== 0) {
        return;
      }
      analytics.coDonationSetToZero({
        id: receiverId,
        receiver_type: receiverType,
        donation_form_type: getDonationFormType({
          receiverId,
          receiverType,
          channel,
          showCodonation
        })
      });
      if (shown) {
        return;
      }
      show();
    };
    $[0] = channel;
    $[1] = receiverId;
    $[2] = receiverType;
    $[3] = show;
    $[4] = showCodonation;
    $[5] = shown;
    $[6] = value;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== channel || $[9] !== onShow || $[10] !== receiverId || $[11] !== receiverType || $[12] !== show || $[13] !== showCodonation || $[14] !== shown || $[15] !== value) {
    t2 = [channel, receiverId, receiverType, show, showCodonation, shown, value, onShow];
    $[8] = channel;
    $[9] = onShow;
    $[10] = receiverId;
    $[11] = receiverType;
    $[12] = show;
    $[13] = showCodonation;
    $[14] = shown;
    $[15] = value;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[17] !== onShow || $[18] !== shown) {
    t3 = () => {
      if (!shown) {
        return;
      }
      onShow?.();
    };
    t4 = [shown, onShow];
    $[17] = onShow;
    $[18] = shown;
    $[19] = t3;
    $[20] = t4;
  } else {
    t3 = $[19];
    t4 = $[20];
  }
  useEffect(t3, t4);
  let t5;
  if ($[21] !== className) {
    t5 = classNames(styles.zeroCodonationMessage, className);
    $[21] = className;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t5) {
    t6 = <I18nHtml className={t5} i18nKey="donate.codonation_box.zero_codonation_message_html" aria-live="polite" />;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== shown || $[26] !== t6) {
    t7 = <Expandable open={shown}>{t6}</Expandable>;
    $[25] = shown;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}
export default ZeroCodonationMessage;